import React from "react";
import "../g.css";

export default function Policy() {
  const ourStore = "Wear & Wonder Boutique LLC";

  return (
    <main className="policy-container">
      <div className="policy-wrapper">
        <h1 className="policy-title">Privacy Policy</h1>
        <p className="policy-date">Last updated: <span>6/28/2024</span></p>

        <section>
          <p>
            This Privacy Policy outlines how <strong>{ourStore}</strong> ("we", "us", or "our") collects, uses, and shares your personal information when you interact with our services. By using our site, you agree to the terms outlined below.
          </p>
        </section>

        <section>
          <h2>Your Personal Information</h2>
          <p>
            Information you share with {ourStore} is only used to serve you better. We don’t share it with third parties without your explicit consent. You may request to view, edit, or delete your data anytime.
          </p>
          <p>
            To opt out of communication, <a href="/Contact-us">Contact Us</a>.
          </p>
        </section>

        <section>
          <h2>1. Policy Updates</h2>
          <p>
            We may revise this policy as needed. Updates will be reflected on this page with a new “Last updated” date.
          </p>
        </section>

        <section>
          <h2>2. What We Collect and How We Use It</h2>
          <p>We collect data based on how you use our services, including:</p>

          <h3>A. Information We Collect</h3>
          <ul>
            <li>Contact details (name, phone, address, email, gender, age range, date of birth) for free gifts</li>
            <li>Order details (billing/shipping, payment status)</li>
            <li>Account info (username, password)</li>
            <li>Shopping behavior</li>
            <li>Customer service communications</li>
          </ul>

          <h3>B. Cookies & Usage Tracking</h3>
          <ul>
            <li>Device info (IP, browser, system, ID)</li>
            <li>Site usage (pages visited, clicks, session data)</li>
          </ul>

          <p>This info helps us improve your experience and our site performance.</p>

          <h3>C. How We Use Your Info</h3>
          <ul>
            <li>To deliver and optimize services</li>
            <li>Customize shopping experiences</li>
            <li>Process payments and fulfill orders</li>
            <li>Send updates/promotions (opt-out available)</li>
            <li>Support and resolve issues</li>
            <li>Enhance website functionality</li>
            <li>Prevent fraud and maintain security</li>
            <li>Comply with laws</li>
          </ul>

          <h3>D. When We Share Your Info</h3>
          <ul>
            <li>Trusted partners (e.g., shipping or payment providers)</li>
            <li>Marketing partners</li>
            <li>Legal authorities, when required</li>
          </ul>
        </section>

        <section>
          <h2>3. Your Rights</h2>
          <ul>
            <li>Request, update, or delete your data</li>
            <li>Unsubscribe from promotional emails</li>
            <li>Disable cookies via browser settings</li>
          </ul>
        </section>

        <section>
          <h2>4. Data Storage</h2>
          <p>
            Your data is retained only as long as necessary to provide services or meet legal requirements.
          </p>
        </section>

        <section>
          <h2>5. Get in Touch</h2>
          <p>
            Questions? <a href="/Contact-us">Contact Us</a>.
          </p>
        </section>
      </div>
    </main>
  );
}
